import { useMutation, useQuery, useQueryClient } from "react-query";
import { axiosGet, axiosPost, axiosPut, reactQueryDefaultOptions } from "../helpers/baseApi";
import { SERVICE_URLS } from "../helpers/serviceUrls";
import { QUERY_KEYS } from "../helpers/queryKeys";

export const useQueryGetBrokerTemplates = (audience, carrierId) => {
  const getBrokerTemplates = async () => {
    return await axiosGet(SERVICE_URLS.BROKER_COMMS_TEMPLATES(audience, carrierId));
  };
  return useQuery(
    [QUERY_KEYS.BROKER_COMMS_TEMPLATES, audience, carrierId],
    getBrokerTemplates,
    { ...reactQueryDefaultOptions, enabled: !!audience },
  );
};

export const useMutateUpsertBrokerTemplate = () => {
  const fn = async (data) => {
    return await axiosPost(SERVICE_URLS.BROKER_COMMS_TEMPLATES_POST, data);
  };
  const queryClient = useQueryClient();
  return useMutation(fn, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.BROKER_COMMS_TEMPLATES]);
    },
  });
};

export const useQueryGetBrokerCommsCarriers = (waveId) => {
  const getBrokerCommsCarriers = async () => {
    return await axiosGet(SERVICE_URLS.BROKER_COMMS_WAVE_CARRIERS(waveId));
  };
  return useQuery(
    [QUERY_KEYS.BROKER_COMMS_WAVE_CARRIERS, waveId],
    getBrokerCommsCarriers,
    { ...reactQueryDefaultOptions, enabled: !!waveId },
  );
};

export const useMutateScheduleBrokerCommsCarriers = (waveId) => {
  const fn = async (data) => {
    return await axiosPost(SERVICE_URLS.BROKER_COMMS_WAVE_CARRIERS(waveId), data);
  };
  const queryClient = useQueryClient();
  return useMutation(fn, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.BROKER_COMMS_WAVE_CARRIERS]);
    },
  });
};

export const useMutateUpdateBrokerCommsCarrier = (waveId) => {
  const fn = async (data) => {
    return await axiosPut(SERVICE_URLS.BROKER_COMMS_WAVE_CARRIER_PUT(waveId, data.notificationWaveCarrierId), data);
  };
  const queryClient = useQueryClient();
  return useMutation(fn, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.BROKER_COMMS_WAVE_CARRIERS]);
    },
  });
};

export const useQueryGetBrokerCommsAudit = (waveId, carrierId) => {
  const getBrokerCommsAudit = async () => {
    return await axiosGet(SERVICE_URLS.BROKER_COMMS_AUDIT(waveId, carrierId));
  };
  return useQuery(
    [QUERY_KEYS.BROKER_COMMS_AUDIT, waveId, carrierId],
    getBrokerCommsAudit,
    reactQueryDefaultOptions,
  );
};

export const useMutateReleaseCarrier = () => {
  const fn = async (data) => {
    return await axiosPut(SERVICE_URLS.CARRIER_RELEASE(data.carrierId), data);
  };
  const queryClient = useQueryClient();
  return useMutation(fn, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.CARRIER_LIST]);
    },
  });
};
